import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import CPage from '@/views/CPage.vue';
import composition from '@/composition';
import ChannelList from '@/components/channel/channel-list.vue';
import HeadView from '@/components/topic/head-view.vue';
export default {
  setup(__props) {
    const {
      ref,
      request,
      getQueryString,
      store,
      wxShare
    } = composition();
    const id = getQueryString().id;
    const topicModel = ref({});
    const categoryModel = ref({});
    const categoryType = ref('');
    request.getTimelineTag(id).then(res => {
      window.zmyCollectionOpenActivityH5(id);
      topicModel.value = res.data;
      topicModel.value.category = res.category;
      categoryModel.value = res.category;
      categoryType.value = res.data.type;
      store.commit('setPageInfo', {
        pageType: pageType(),
        id: topicModel.value.id
      });
      let desc = '同城友圈-分享我的趣味生活';

      if (categoryType.value == 'NEIGHBOR') {
        // 友邻
        desc = '友邻-分享我的社区新鲜事';
      }

      wxShare('#' + res.data.name, desc);

      _poc_topicPage(topicModel.value.name, topicModel.value.id);
    });
    const activeName = ref(0);
    const types = ref([{
      name: '最新',
      order: ''
    }, {
      name: '最热',
      order: 'hotCount'
    }]);
    setTimeout(() => {
      if (localStorage.getItem('_user_id')) {
        // eslint-disable-next-line no-undef
        qaplus.event.setMetaInfo(localStorage.getItem('_user_id')); // eslint-disable-next-line no-undef

        pocplus.event.config('user_unique_id', localStorage.getItem('_user_id'));
      }
    }, 1000);

    function _poc_topicPage(title, id) {
      // [埋点] 话题页访问
      let _poc_event_params = {
        topic_id: id,
        topic_name: title
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('topic_page', 2001, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_topic', _poc_event_params);
    } // 页面类型


    const pageType = () => {
      const pageTypeList = {
        MOMENT: 2,
        NEIGHBOR: 11,
        BROADCAST: 2
      };
      return pageTypeList[categoryType.value];
    };

    store.dispatch('_initApp');
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(CPage, {
        model: topicModel.value,
        showPublish: true
      }, {
        main: _withCtx(() => [_createVNode(HeadView, {
          model: topicModel.value,
          categoryModel: categoryModel.value
        }, null, 8, ["model", "categoryModel"]), _createVNode(_unref(_Tabs), {
          active: activeName.value,
          "onUpdate:active": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          "line-width": "0",
          swipeable: "",
          shrink: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item, index) => {
            return _openBlock(), _createBlock(_unref(_Tab), {
              title: item.name,
              name: index,
              key: index
            }, {
              default: _withCtx(() => [_createVNode(ChannelList, {
                order: item.order,
                tagId: _unref(id),
                type: categoryType.value
              }, null, 8, ["order", "tagId", "type"])]),
              _: 2
            }, 1032, ["title", "name"]);
          }), 128))]),
          _: 1
        }, 8, ["active"])]),
        _: 1
      }, 8, ["model"]);
    };
  }

};